module.exports = __webpack_public_path__ + "static/device_laptop_apple_light-dfad082b48cadd63d79d86e725073a04.png";